export type RecurrentModalProps = {
  id: string;
  readDay: string | null; // yyyymmdd
  hidden: boolean;
};

export const getRecurrentModalStorage = (): RecurrentModalProps[] | null => {
  const reviewRead = localStorage.getItem('reviewRead');
  const recurrentModal = localStorage.getItem('recurrentModal');

  if (reviewRead === null && recurrentModal) {
    return JSON.parse(recurrentModal) as RecurrentModalProps[];
  } else if (reviewRead && recurrentModal === null) {
    localStorage.removeItem('reviewRead');

    const reviewReadStorage = JSON.parse(reviewRead) as RecurrentModalProps[];
    setRecurrentModalStorage(reviewReadStorage);
    return reviewReadStorage;
  } else if (reviewRead && recurrentModal) {
    localStorage.removeItem('reviewRead');

    return JSON.parse(recurrentModal) as RecurrentModalProps[];
  } else {
    return null;
  }
};

export const setRecurrentModalStorage = (list: RecurrentModalProps[]): void => {
  const reviewRead = localStorage.getItem('reviewRead');
  const recurrentModal = localStorage.getItem('recurrentModal');

  if (
    (reviewRead && recurrentModal === null) ||
    (reviewRead && recurrentModal)
  ) {
    localStorage.removeItem('reviewRead');
  }
  localStorage.setItem('recurrentModal', JSON.stringify(list));
};
